/**
 * @name: emailRoutes
 * @author: weiyong
 * @date: 2026-01-22 17:22
 * @description：邮件管理子路由配置
 * @update: 2026-01-22 17:22
 *
 */

// 写信页面
const EmailComposePage = () => import('../views/EmailComposePage.vue');
// 收件箱
const EmailInboxPage = () => import('../views/EmailInboxPage.vue');
// 邮件详情
const EmailDetailPage = () => import('../views/EmailDetailPage.vue');
// 已发送
const EmailSentPage = () => import('../views/EmailSentPage.vue');
// 草稿箱
const EmailDraftsPage = () => import('../views/EmailDraftsPage.vue');
// 垃圾箱
const EmailTrashPage = () => import('../views/EmailTrashPage.vue');
// 待办邮件
const EmailTodoPage = () => import('../views/EmailTodoPage.vue');
// 标星邮件
const EmailStarredPage = () => import('../views/EmailStarredPage.vue');
// 所有邮件
const EmailAllPage = () => import('../views/EmailAllPage.vue');
// 邮件监控
const EmailMonitorPage = () => import('../views/EmailMonitorPage.vue');
// 邮件设置
const EmailSettingsPage = () => import('../views/EmailSettingsPage.vue');
// 附件中心
const EmailAttachmentCenterPage = () => import('../views/EmailAttachmentCenterPage.vue');
// 空间管理
const EmailSpaceManagePage = () => import('../views/EmailSpaceManagePage.vue');
// 模版管理
const EmailTemplateManagePage = () => import('../views/EmailTemplateManagePage.vue');
// 标签邮件
const EmailLabelPage = () => import('../views/EmailLabelPage.vue');
// 文件夹邮件
const EmailFolderPage = () => import('../views/EmailFolderPage.vue');
// 标签首页
const emailMainPage = () => import('../index.vue');


export default [
   {
        path: '/emailMainPage/compose',
        name: 'EmailCompose',
        component: EmailComposePage,
        meta: {
          title: '写信',
          rightPanel: 'contacts', // 右侧显示联系人树
        },
      },
      {
        path: '/emailMainPage/inbox',
        name: 'EmailInbox',
        component: EmailInboxPage,
        meta: {
          title: '收件箱',
          rightPanel: 'none', // 右侧不显示面板
        },
      },
      {
        path: '/emailMainPage/detail/:id',
        name: 'EmailDetail',
        component: EmailDetailPage,
        meta: {
          title: '邮件详情',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/sent',
        name: 'EmailSent',
        component: EmailSentPage,
        meta: {
          title: '已发送',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/drafts',
        name: 'EmailDrafts',
        component: EmailDraftsPage,
        meta: {
          title: '草稿箱',
          rightPanel: 'contacts',
        },
      },
      {
        path: '/emailMainPage/trash',
        name: 'EmailTrash',
        component: EmailTrashPage,
        meta: {
          title: '垃圾箱',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/todo',
        name: 'todo',
        component: EmailTodoPage,
        meta: {
          title: '待办邮件',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/starred',
        name: 'starred',
        component: EmailStarredPage,
        meta: {
          title: '标星邮件',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/all',
        name: 'all',
        component: EmailAllPage,
        meta: {
          title: '所有邮件',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/monitor',
        name: 'EmailMonitor',
        component: EmailMonitorPage,
        meta: {
          title: '邮件监控',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/settings',
        name: 'EmailSettings',
        component: EmailSettingsPage,
        meta: {
          title: '邮件设置',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/attachment',
        name: 'EmailAttachment',
        component: EmailAttachmentCenterPage,
        meta: {
          title: '附件中心',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/space',
        name: 'EmailSpace',
        component: EmailSpaceManagePage,
        meta: {
          title: '空间管理',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/template',
        name: 'EmailTemplate',
        component: EmailTemplateManagePage,
        meta: {
          title: '模版管理',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/label',
        name: 'EmailLabel',
        component: EmailLabelPage,
        meta: {
          title: '标签邮件',
          rightPanel: 'none',
        },
      },
      {
        path: '/emailMainPage/folder',
        name: 'EmailFolder',
        component: EmailFolderPage,
        meta: {
          title: '文件夹邮件',
          rightPanel: 'none',
        },
      }
];
